<div class="planning">
  @for (day of planningObject; track day) {
    <div class="day">
      <input type="checkbox" [disabled]="!isEditMode" [id]="day.day" [(ngModel)]="day.enable" (change)="changeModel()">
      <label [for]="day.day"></label>
      <div class="title">{{ "administration.day."+ day.day | translate}}</div>
      <div class="from">
        <span>{{"administration.planning.from" | translate}}</span>
        <input class="input-time" [disabled]="!isEditMode || !day.enable" [(ngModel)]="day.timeslots[0].startTime" type="time" id="appt" name="appt" min="00:00" max="23:59" (change)="changeModel()">
        <span>{{"administration.planning.to" | translate}}</span>
        <input class="input-time" [disabled]="!isEditMode || !day.enable" [(ngModel)]="day.timeslots[0].endTime" type="time" id="appt" name="appt" min="00:00" max="23:59" (change)="changeModel()">
        <span class="mr-10 ml-10">{{"administration.planning.and" | translate}}</span>
        <span>{{"administration.planning.from" | translate}}</span>
        <input class="input-time" [disabled]="!isEditMode || !day.enable" [(ngModel)]="day.timeslots[1].startTime" type="time" id="appt" name="appt" min="00:00" max="23:59" (change)="changeModel()">
        <span>{{"administration.planning.to" | translate}}</span>
        <input class="input-time" [disabled]="!isEditMode || !day.enable" [(ngModel)]="day.timeslots[1].endTime" type="time" id="appt" name="appt" min="00:00" max="23:59" (change)="changeModel()">
      </div>
    </div>
  }

</div>
